import React, { forwardRef, useEffect, useState } from 'react';
import Select, { InputActionMeta, Props } from 'react-select';

import DropdownIndicator from '../components/DropdownIndicator';
import styles from './dropdown.module.scss';

export interface IDropdownProps<TOption> extends Props<TOption> {
  needToShowInputTextOnBlur?: boolean;
}

function DropdownComponent<TOption = any>(props: IDropdownProps<TOption>, ref?: React.Ref<any>) {
  const {
    needToShowInputTextOnBlur,
    className,
    classNamePrefix,
    components,
    onInputChange,
    inputValue,
    options,
    ...restProps
  } = props;
  const [inputText, setInputText] = useState('');
  const [cachedOptions, setCachedOptions] = useState<Props<TOption>['options']>([]);

  const handleInputChange = (newValue: string, action: InputActionMeta) => {
    if (action.action !== 'input-blur' && action.action !== 'menu-close') {
      setInputText(newValue);
    }

    if (newValue.length > 0) {
      onInputChange?.(newValue, action);
    }
    else if (!needToShowInputTextOnBlur) {
      setCachedOptions([]);
    }
  };

  useEffect(() => {
    setCachedOptions(options);
  }, [options]);

  return (
    <Select
      ref={ref}
      className={styles.dropdown}
      classNamePrefix="dropdown"
      components={components ?? { DropdownIndicator }}
      inputValue={inputValue ?? inputText}
      onInputChange={handleInputChange}
      options={cachedOptions}
      {...restProps}
    />
  );
}

// eslint-disable-next-line max-len
const Dropdown = forwardRef(DropdownComponent) as <OptionType>(props: IDropdownProps<OptionType>) => JSX.Element;

export default Dropdown;